<div class="viewer-header">
  <dgx-zoom-controls
    *ngIf="controls.currentScale$ | async as scale"
    [currentScale]="scale"
    (onZoomIn)="controls.zoomIn()"
    (onZoomOut)="controls.zoomOut()"
  ></dgx-zoom-controls>
</div>
